import React, { useEffect, useState } from 'react';
import 'moment/dist/locale/tr';
import 'moment/dist/locale/ar-kw';
import 'moment/dist/locale/es';

import trTr from 'antd/es/locale/tr_TR';
import enUS from 'antd/es/locale/en_US';
import arEg from 'antd/es/locale/ar_EG';
import esES from 'antd/es/locale/es_ES';

import i18n from 'src/i18n';

import App from './App';
import ConfigProvider from 'antd/es/config-provider';

const localizationMap = {
  tr: trTr,
  en: enUS,
  ar: arEg,
  es: esES,
};

type SupportedLang = keyof typeof localizationMap;

const LocalizationWrapper = () => {
  const [language, setLanguage] = useState<SupportedLang>((i18n.language as SupportedLang) || 'en');

  useEffect(() => {
    const listener = (lng: string) => {
      setLanguage(lng as SupportedLang);
    };

    i18n.on('languageChanged', listener);

    return () => {
      i18n.off('languageChanged', listener);
    };
  }, []);

  return (
    <ConfigProvider locale={localizationMap[language]} direction={i18n.dir()}>
      <App />
    </ConfigProvider>
  );
};

export default LocalizationWrapper;
